module.exports = __webpack_public_path__ + "img/HU14479917.598cd043.png";